import { MessageCircle, MapPin } from 'lucide-react';
import { LOJAS, linkWhatsApp } from '../data/produtos';
import { useLogo } from '../hooks/useLogo';

export default function Footer() {
  const logo = useLogo();
  return (
    <footer data-testid="footer-section" className="bg-mk-bluedark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col items-center gap-3 text-center">
          <img src={logo} alt="MK Eletromóveis" className="h-16 w-16 rounded-full object-contain shadow-lg" />
          <p className="font-heading text-xl font-extrabold">MK Eletromóveis</p>
          <p className="text-sm text-blue-200/80">Encontre tudo para sua casa.</p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 max-w-2xl mx-auto">
          {LOJAS.map((loja, i) => (
            <a
              key={loja.id}
              data-testid={`footer-loja${i + 1}-contact`}
              href={linkWhatsApp(loja, null)}
              target="_blank"
              rel="noopener noreferrer"
              className="group rounded-2xl border border-white/10 bg-white/5 p-5 text-center transition-colors duration-300 hover:border-mk-green/60 hover:bg-white/10"
            >
              <p className="flex items-center justify-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-blue-200/80">
                <MapPin size={13} />
                {loja.cidade}
              </p>
              <p className="mt-1.5 font-heading text-base font-bold">{loja.nome}</p>
              <p className="mt-2 inline-flex items-center gap-2 rounded-full bg-mk-green px-4 py-2 text-sm font-bold text-white transition-colors group-hover:bg-mk-greendark">
                <MessageCircle size={15} strokeWidth={2.5} />
                {loja.telefone}
              </p>
            </a>
          ))}
        </div>

        <p className="mt-10 text-center text-xs text-blue-200/60">
          Preços à vista conforme catálogo vigente. Consulte condições de pagamento e disponibilidade pelo WhatsApp.
        </p>
        <p className="mt-2 text-center text-xs text-blue-200/40">
          © {new Date().getFullYear()} MK Eletromóveis — Catálogo Digital
        </p>
      </div>
    </footer>
  );
}
